const publish = (event, data) => window.dispatchEvent(new CustomEvent(event, {
  bubbles: false,
  cancelable: true,
  detail: data
}));

const subscribe = (event, callback) => window.addEventListener(event, e => {
  callback(e.detail);
});

const unsubscribe = (event, callback) => window.removeEventListener(event, callback);

export default {};
export { publish, subscribe, unsubscribe };